import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

import user from "./user";
import courses from "./courses";
import quiz from "./quiz";
import showcases from "./showcases";
import podcasts from "./podcasts";
import lives from "./lives";
import comments from "./comments";
import students from "./students";
import trails from "./trails";
import search from "./search";
import community from "./community";
import workout from "./workout";

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  state,
  mutations,
  modules: {
    user,
    courses,
    quiz,
    showcases,
    podcasts,
    lives,
    comments,
    students,
    trails,
    search,
    community,
    workout
  }
});
